import React from "react";
import "./../footer/Footer.css";
import { Grid, Stack, Typography, Box, Button, Divider } from "@mui/material";
import logo from "./../images/logo.png";
import Avatar from "@mui/material/Avatar";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { lightBlue } from "@mui/material/colors";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom"; // Import useNavigate from React Router

const Footer = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const aMediaQuery = useMediaQuery("(min-width: 365px) and (max-width: 450px)");

  const navigate = useNavigate(); // Initialize the navigate function
  const linkStyle = {
    textDecoration: "none",
    marginLeft: '8px'
  };

  const linkBtn = {
    color: "white",
    textDecoration: "none",
    fontSize: vMediaQuery ? "14px" : "16px",
    fontFamily: "EB Garamond",
    textTransform: "capitalize",
    "&:hover": {
      textDecoration: "underline",
      background: "none",
    },
  };

  const phoneNumber = "+91 9585545054";
  //const mobileNumber = "+91 99448 59629"

  const handleAboutClick = () => {
    navigate("/about"); // Navigate to the About page when the button is clicked
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top of the page
  };

  return (
    <footer className="footer">
      <Box
        sx={{
          flexGrow: 1,
          padding: vMediaQuery ? "20px 0px" : "40px 60px 40px 70px",
        }}
      >
        <Grid container>
          <Grid item xs={12} md={3} lg={4} >
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{ padding: vMediaQuery ? "0px 8px" : "0px 10px" }}

              >
                <Stack
                  direction={"row"}
                  alignItems="center"
                  textAlign="center"
                  spacing={0}
                  sx={{ padding: "10px 0px" }}
                >
                  <Grid container>
                    <Grid item xs={4.5} md={3.5}
                    > 
                     <img className="footerImg" src={logo} alt="Logo" /></Grid>
                    <Grid item xs={7} md={8}>   <Typography sx={{ fontSize: vMediaQuery ? "22px" : "24px", fontWeight: 600, marginRight: vMediaQuery ? '20px' : '30px' }}>
                      GDR Consultancy Services
                    </Typography></Grid>
                  </Grid>
                </Stack>
                <Typography
                  variant={vMediaQuery ? "body2" : "body1"}
                  className={"footer-container"}
                >
                  GDR Consultancy – A recognized Software Development Company.
                  We help your businesses get innovative solutions and
                  transformation with our Experts.
                </Typography>

                <Grid container paddingX='10px'>
                  <Grid item xs={6}>
                    {vMediaQuery || (
                      <h2 style={{ paddingTop: "6px" }}>Follow Us</h2>
                    )}

                    {vMediaQuery && (
                      <h3 style={{ padding: "2px 10px" }}>Follow Us</h3>
                    )}
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: 'right', display: 'flex', justifyContent: 'right' }}>
                    <Stack direction={"column"} spacing={0} marginTop={"16px"} >
                      <a
                        href="https://www.linkedin.com/in/gdr-consultancy-services-8430872ab/"
                        style={linkStyle}
                      >
                        <Avatar
                          variant="rounded"
                          sx={{ bgcolor: lightBlue[500] }}
                        >
                          <LinkedInIcon />
                        </Avatar>
                      </a>
                      <Typography variant="caption" sx={{ textAlign: 'center' }}>
                        <a
                          style={linkBtn}
                          href={`https://www.linkedin.com/in/gdr-consultancy-services-8430872ab/`}
                        >
                          Linked in
                        </a>
                      </Typography>

                    </Stack>
                  </Grid>
                </Grid>

              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}

            padding={vMediaQuery ? "0px 10px 10px 10px" : "0px 10px 0px 80px"}
          >
            {vMediaQuery || <h1>Company</h1>}

            {vMediaQuery && <h2>Company</h2>}
            <Stack
              direction="row"
            >
              <ArrowForwardIcon sx={{ marginTop: "9px" }} />
              <Button
                onClick={handleAboutClick}
                sx={{
                  color: "white",
                  fontSize: "16px",
                  textTransform: "capitalize",
                  "&:hover": {
                    textDecoration: "underline",
                    background: "none",
                  },
                }}
              >
                Know About us!
              </Button>
            </Stack>
            <Grid container paddingTop={vMediaQuery ? '10px' : 3} >
              <Grid item xs={2} md={1.6} lg={1.8}>
                <Avatar sx={{ bgcolor: '#964b00' }}>
                  <ContactMailOutlinedIcon />
                </Avatar>
              </Grid>
              <Grid item xs={10} md={10.4} lg={10.2} >
                {!vMediaQuery && (
                  <h2 style={{ margin: "0px 0px 6px 0px" }}>Email Us</h2>

                )}
                {vMediaQuery && (
                  <h3 style={{ margin: "0px 0px 6px 0px" }}>Email Us</h3>

                )}
                <div>
                  <address>
                    <a
                      style={{
                        color: "white",
                        fontSize: vMediaQuery ? "14px" : "16px",
                        fontFamily: "EB Garamond",
                        fontStyle: "normal",
                        textDecoration: "none"
                      }}
                      href="mailto:Info@gdrconsultancyservices.onmicrosoft.com"
                    >
                      Info@gdrconsultancyservices.onmicrosoft.com
                    </a>
                  </address>
                </div>
              </Grid>

            </Grid>

          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            padding={"0px 10px"}

          >
            <div id={"contactInfo"}>
              {vMediaQuery || <h1>Contact Info!</h1>}

              {vMediaQuery && <h2>Contact Info!</h2>}
              <Grid container padding={vMediaQuery ? "0px 4px" : "0px"}>
                <Grid item xs={2} md={1.6} lg={1.6}>
                  <Avatar sx={{ bgcolor: '#4285f4' }}>
                    <PinDropOutlinedIcon />
                  </Avatar>
                </Grid>
                <Grid item xs={10} md={10.4} lg={10.4} >
                  {!vMediaQuery && (
                    <h2 style={{ margin: "0px 0px 8px 0px" }}>Location</h2>

                  )}
                  {vMediaQuery && (
                    <h3 style={{ margin: "0px 0px 8px 0px" }}>Location</h3>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <div style={{ marginTop: "2px", marginRight: vMediaQuery ? '0px' : '30px' }}>
                      <h4 style={{ margin: '0px 0px 4px 0px' }}>India</h4>
                      <address
                        style={{ fontFamily: "EB Garamond", fontStyle: "normal", fontSize: vMediaQuery ? "14px" : "16px" }}
                      >
                        No.2, 1st Cross Street,
                        {vMediaQuery || <br />}Bharathidashan Nagar,

                        <br />

                        Mudaliarpet,
                        <br />

                        Puducherry - 605004.
                      </address>
                    </div>
                    {/*<div style={{ marginTop: "2px" }}>
                      <h4 style={{ margin: '0px 0px 4px 0px' }}>United States</h4>
                      <address
                        style={{ fontFamily: "EB Garamond", fontStyle: "normal", fontSize: vMediaQuery ? "14px" : "16px" }}
                      >
                        22246, Victory Blvd,
                        {vMediaQuery || <br />}Woodland Hills.
                        {vMediaQuery && <br />}
                        {vMediaQuery || <br />}
                        California - 91367.
                      </address>
                    </div>*/}
                  </div>
                </Grid>
                <Grid item xs={2} md={1.6} lg={1.6} paddingTop={2}>
                  <Avatar sx={{ bgcolor: '#19a7a4' }}>
                    <PhoneInTalkOutlinedIcon />
                  </Avatar>
                </Grid>
                <Grid item xs={10} md={10.4} lg={10.4} paddingTop={2}>
                  {!vMediaQuery && (
                    <h2 style={{ margin: "0px 0px 6px 0px" }}>Phone Us</h2>

                  )}
                  {vMediaQuery && (
                    <h3 style={{ margin: "0px 0px 6px 0px" }}>Phone Us</h3>

                  )}
                  <div>
                    <a style={linkBtn} href={`tel:${phoneNumber}`}>
                      Office : {phoneNumber}
                    </a>

                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>

        <Divider
          sx={{
            backgroundColor: "white",

            margin: vMediaQuery
              ? "20px 10px"
              : "30px 20px  26px 10px",
          }}
        />
        <Grid container>
          <Grid item xs={12}>
            <Stack
              direction={"row"}
              sx={{
                justifyContent: "space-between",
                padding: vMediaQuery ? "0px 20px" : "0px 40px 0px 80px",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: vMediaQuery ? "10px" : "14px",
                  marginLeft: vMediaQuery ? "0px" : "-50px",
                }}
              >
                © 2021 – GDR Consultancy Services.
              </Typography>
              <a style={{ fontSize: vMediaQuery ? "12px" : "16px" }}>
                Contact Us
              </a>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </footer>
  );
};

export default Footer;
